import React from "react";
import { Navigate } from "react-router-dom";
import { useJobContext } from "../context/JobContext";

interface AuthMiddlewareProps {
    children: React.ReactNode;
}

const AuthMiddleware = ({ children }: AuthMiddlewareProps) => {
    const { user } = useJobContext();

    if (!user) {
        return <Navigate to="/cms/login" replace />;
    }

    return <React.Fragment>{children}</React.Fragment>;
};

export default AuthMiddleware;
